









import { Component, Vue } from "vue-property-decorator";
import AppIconTextButton from "@/components/_shared/buttons/app-icon-text-button.vue";
import ProductDetailModal from "@/components/_shared/modals/product-detail-modal.vue";
import StockMovementGrid from "@/components/stock/stock-movement-grid.vue";
import { DataSource } from "@/utils/grid/datasource";
import { stockMovementApiProvider } from "@/providers/stock-movement-api-provider";

@Component({
  name: "stock-movement-list-page",
  components: { StockMovementGrid, AppIconTextButton, ProductDetailModal },
})
export default class StockMovementListPage extends Vue {
  datasource: DataSource;

  breadcrumbs = [{ text: this.$t("app.title") }, { text: this.$t("stock.movement_page_title") }];

  async beforeMount() {
    this.$route.meta.title = this.$t("stock.movement_page_title");
    this.datasource = DataSource.from(stockMovementApiProvider);
  }
}
